











































import { Component, Prop, Vue } from "vue-property-decorator"
import AppProgramaGrupoPresentacion from "@/components/Programa/AppProgramaGrupoPresentacion.vue";
import AppProgramaMaterial from "@/components/Programa/AppProgramaMaterial.vue";
import AppProgramaExpositores from "@/components/Programa/AppProgramaExpositores.vue";
import AppProgramaComentaristas from "@/components/Programa/AppProgramaComentaristas.vue";
import { Presentacion } from "@/Interfaces/Programa/Presentacion";
import AppProgramaModeradores from "@/components/Programa/AppProgramaModeradores.vue";

@Component({
  components: {
    AppProgramaModeradores,
    AppProgramaExpositores,
    AppProgramaMaterial,
    AppProgramaGrupoPresentacion
  }
})
export default class AppProgramaPresentacion extends Vue {
  @Prop({ required: true }) presentacion: Presentacion;
}
